import './App.css';
import firebaseConfig from "./firebaseConfig.json";
import { pathnames, AuthProvider, MainMenu, PublicTemplate, ResetPassword, SignIn, SignUp, UserMenu, UserProfile, UserUpdateEmail, UserUpdateName, UserUpdatePassword, UserDelete, FireactProvider, ActionPages, UserAccount } from './lib/core';
import OpenTechPlusTemplate from "./template/OpenTechPlusTemplate";
import NavProvider from "./template/NavProvider";
import { BrowserRouter, Routes, Navigate } from "react-router-dom";
import { Route } from "react-router-dom";
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { CircularProgress, Box } from '@mui/material';
import authMethods from "./authMethods.json";
import { CreateSubscription, ListSubscriptions, PermissionRouter, Settings, SubscriptionMenu, ListUsers, SubscriptionProvider, ListInvoices, ManagePaymentMethods, ChangePlan, CancelSubscription, UpdateBillingDetails } from './lib';
import subPathnames from './pathnames.json';
import SaaSConfig from './config.json';
import { Divider, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import Avatar from '@mui/material/Avatar';
import Home from './components/Home';
import SubscriptionHome from './components/Subscription/SubscriptionHome';
import About from './components/About';
import IosApp from './components/IosApp';
import ForClientPage from './components/ForClientPage';
//import AdminPanel from './components/AdminPanel';
import {AdminPanel, AdminWebsiteUsers, AdminCoupons, AdminEarnings, AdminInventory} from './components/admin';
import {AdminPageProvider} from "./components/admin/AdminPageContext";
import Faq from './components/Faq';
import ForProviderPage from './components/ForProviderPage';
import Contact from './components/Contact';
import DiditCallback from './components/DiditCallback'
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Search from './components/Search';
import AiImage from './components/AiImage';
import Note from './components/Note';
import NotificationsBell from './components/NotificationsBell'
import Uploader from './components/Uploader';
import Media from './components/Media';
import Dashboard from './components/Dashboard';
import Treatments from './components/Treatments';
import Payment from './components/Payment';
import Activity from './components/Activity';
import Stats from './components/Stats';
import NurseProfile from './components/NurseProfile';
import OrderDetails from './components/OrderDetails';
import Schedule from './components/Schedule';
import Orders from './components/Orders';
import Appointment from './components/Appointment';
import Post from './components/Group/Post';
import OtpAuthRoutes from './components/OtpAuthRoutes';
import { useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Landing from './components/Landing';
import Agenda from './components/Agenda';
import { AppProvider } from './components/common/AppContext';

const Brand = "Living Waters";

const Logo = ({size, color}) => {
    const logoColor = color || 'warning';
    return (
        <Avatar
          alt="Living Waters"
          src="/web-app-manifest-192x192.png"
          sx={{ width: 56, height: 56 }}
        />
    );
}

const Loader = ({size}) => {
    let cpSize = "60px";
    switch(size){
        case "small":
            cpSize = "30px";
            break;
        case "medium":
            cpSize = "35px";
            break;
        case "large":
            cpSize = "60px";
            break;
        default:
            cpSize = "35px";
            break;
    }
    return (
        <Box sx={{ mt: 5, display: 'flex', justifyContent: "center", alignItems: "center"}}>
            <CircularProgress color="warning" size={cpSize} />
            <div style={{position: "absolute" }}>
                <Logo size={size} />
            </div>
        </Box>
    );
}

function App() {

    // merge pathnames
    for(var key in subPathnames){
        pathnames[key] = subPathnames[key];
    }

    const config = {
        firebaseConfig: firebaseConfig,
        brand: "Living Waters",
        pathnames: pathnames,
        authProviders: authMethods,
        saas: SaaSConfig
    }
    
    const [extensionMenu, setExtensionMenu] = useState([]);
    
    const enableEM = (name) => {
        //console.log("name ", name);
        /*
         Push value at the end:

         setArray(oldArray => [...oldArray,newValue] );
         Push value at the start:

         setArray(oldArray => [newValue,...oldArray] );
        */
        if (name) {
            setExtensionMenu(extensionMenu => [...extensionMenu, name]);
        } else {
            setExtensionMenu([]);
        }
        return;
    }
    
    const disableEM = () => {
        //console.log("disableEM ");
        setExtensionMenu([]);
        return;
    }
    
    const CustomItems = () => {
        return (
            <NavLink to="/" style={{textDecoration:'none'}} key="custom">
                <ListItemButton>
                    <ListItemIcon><HomeIcon /></ListItemIcon>
                    <ListItemText primary={<Typography color="textPrimary">Custom</Typography>} />
                </ListItemButton>
            </NavLink>
        );
    }

        const themeLight = createTheme({
            palette: {
                mode: 'light',
                    primary: {
                        main: '#C5ECE0',
                        light: '#E8FBF7',
                        dark: '#7FBFAF',
                        contrastText: '#042027'
                    },
                    secondary: {
                        main: '#4DB6AC',
                        light: '#90E0EF',
                        dark: '#2B8F87',
                        contrastText: '#042027'
                    },
                    background: {
                        default: '#FAFEFD',
                        paper: '#FFFFFF'
                    },
                    text: {
                        primary: '#042027',
                        secondary: '#35585B'
                    },
                    info: {
                        main: '#38ADA9'
                    },
                    warning: {
                        main: '#E9AFA3'
                    }
            },
            components: {
                MuiButton: {
                    variants: [
                        {
                            props: { variant: 'outlined' },
                            style: {
                                borderColor: '#000000',
                                color: '#000000',
                                textTransform: 'none',
                                '&:hover': {
                                    borderColor: '#000000',
                                    backgroundColor: 'rgba(0,0,0,0.06)'
                                }
                            }
                        },
                        {
                            props: { variant: 'contained' },
                            style: {
                                backgroundColor: '#000000',
                                color: '#ffffff',
                                textTransform: 'none',
                                boxShadow: 'none',
                                '&:hover': {
                                    backgroundColor: '#111111'
                                }
                            }
                        }
                    ]
                },
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#888',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#042027',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: '#666',
                                '&.Mui-focused': {
                                    color: '#042027',
                                },
                            },
                        },
                    },
                },
            }
        });
                
    return (
        <ThemeProvider theme={themeLight}>
        <FireactProvider config={config}>
            <AuthProvider firebaseConfig={firebaseConfig} brand={Brand}>
                <BrowserRouter>
                <AppProvider>
                    <Routes>
                        <Route element={<OtpAuthRoutes loader={<Loader size="large" />} />} >
                            <Route element={<OpenTechPlusTemplate logo={<Logo size="large" />} toolBarMenu={<UserMenu />} extensionMenu={extensionMenu}  drawerMenu={<MainMenu  customItems={<CustomItems />} />} />}>

                                //with default Nav/Menu and extension
                                <Route element={<NavProvider loader={<Loader size="large" />} />} >
                                    <Route exact path={pathnames.Subscription+"/"} element={<SubscriptionHome loader={<Loader size="large" />} enableExtensionMenu={enableEM} />} />
                                </Route>
                                
                                //with default Nav/Menu
                                <Route element={<NavProvider loader={<Loader size="large" />} enableExtensionMenu={disableEM} />} >
                                    <Route exact path="/" element={<Landing loader={<Loader size="large" />} />} />
                                    <Route exact path="/booking" element={<Home loader={<Loader size="large" />} />} />
                                    <Route exact path="/about" element={<About loader={<Loader size="large" />} />} />
                                    <Route exact path="/ios-app" element={<IosApp loader={<Loader size="large" />} />} />
                                    <Route exact path="/client" element={<ForClientPage loader={<Loader size="large" />} />} />
                                    <Route exact path="/admin" element={<AdminPanel loader={<Loader size="large" />} />} />
                                    <Route exact path="/faq" element={<Faq loader={<Loader size="large" />} />} />
                                    <Route exact path="/provider" element={<ForProviderPage loader={<Loader size="large" />} />} />
                                    <Route exact path="/contact" element={<Contact loader={<Loader size="large" />} />} />
                                    <Route exact path="/privacy" element={<Privacy loader={<Loader size="large" />} />} />
                                    <Route exact path="/terms" element={<Terms loader={<Loader size="large" />} />} />
                                    <Route exact path="/search" element={<Search loader={<Loader size="large" />} />} />
                                    <Route exact path="/note" element={<Note loader={<Loader size="large" />} />} />
                                    <Route exact path="/uploader" element={<Uploader loader={<Loader size="large" />} />} />
                                    <Route exact path="/media" element={<Media loader={<Loader size="large" />} />} />
                                    <Route exact path="/stats" element={<Stats loader={<Loader size="large" />} />} />
                                    <Route exact path="/ai" element={<AiImage loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.ListSubscriptions} element={<ListSubscriptions loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.ListNurse} element={<Navigate to="/" />} />
                                    <Route exact path={pathnames.NurseProfile} element={<NurseProfile loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.OrderDetails} element={<OrderDetails loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.Schedule} element={<Schedule loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.ListSchedules} element={<Dashboard loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.Treatments} element={<Treatments loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.Agenda} element={<Agenda loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.ListOrders} element={<Orders loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.Appointment} element={<Appointment loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.ListAppointments} element={<Activity loader={<Loader size="large" />} />} />
                                    <Route exact path='/payment' element={<Payment loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.CreateSubscription} element={<CreateSubscription />} />
                                    <Route exact path={pathnames.UserProfile} element={<UserProfile />} />
                                    <Route exact path={pathnames.UserUpdateEmail} element={<UserUpdateEmail />} />
                                    <Route exact path={pathnames.UserUpdateName} element={<UserUpdateName />} />
                                    <Route exact path={pathnames.UserUpdatePassword} element={<UserUpdatePassword />} />
                                    <Route exact path={pathnames.UserDelete} element={<UserDelete />} />
                                    <Route exact path={pathnames.UserAccount} element={<UserAccount  loader={<Loader size="large" />} />} />
                                    <Route exact path={pathnames.Notification} element={<NotificationsBell  loader={<Loader size="large" />} />} />
                                    <Route path={pathnames.Admin} element={<AdminPageProvider />} >
                                        <Route exact path={pathnames.Admin} element={<AdminPanel />} />
                                        <Route exact path={pathnames.AdminWebsiteUsers} element={<AdminWebsiteUsers />} />
                                        <Route exact path={pathnames.AdminCoupons} element={<AdminCoupons />} />
                                        <Route exact path={pathnames.AdminEarnings} element={<AdminEarnings />} />
                                        <Route exact path={pathnames.AdminInventory} element={<AdminInventory />} />
                                    </Route>
                                </Route>
                                //with Nav/Menu extension
                                //subscription section
                                <Route path={pathnames.Subscription} element={<SubscriptionProvider loader={<Loader size="large" />} enableExtensionMenu={enableEM} />} >
                                    {/*
                                        <Route element={<PermissionRouter permissions={["access"]} />} >
                                            <Route exact path={pathnames.Subscription+"/"} element={<SubscriptionHome />} />
                                        </Route>
                                    */}
                                        <Route element={<PermissionRouter permissions={["access"]} />} >
                                            <Route exact path={pathnames.Post} element={<Post loader={<Loader size="large" />} />} />
                                        </Route>
                                        <Route element={<PermissionRouter permissions={["admin"]} />} >
                                            <Route exact path={pathnames.Settings} element={<Settings loader={<Loader size="large" />} />} />
                                            <Route exact path={pathnames.ListUsers} element={<ListUsers loader={<Loader size="large" />} />} />
                                            <Route exact path={pathnames.ListInvoices} element={<ListInvoices loader={<Loader size="large" />} />} />
                                            <Route exact path={pathnames.ManagePaymentMethods} element={<ManagePaymentMethods loader={<Loader size="large" />} />} />
                                            <Route exact path={pathnames.UpdateBillingDetails} element={<UpdateBillingDetails loader={<Loader size="large" />} />} />
                                            <Route exact path={pathnames.ChangePlan} element={<ChangePlan />} />
                                            <Route exact path={pathnames.CancelSubscription} element={<CancelSubscription />} />
                                        </Route>
                                </Route>
                            </Route>
                        </Route>
                                     
                        <Route element={<PublicTemplate />}>
                            <Route path={pathnames.SignIn} element={
                                <SignIn
                                    logo={<Logo size="large" />}
                                />
                            } />
                            <Route path={pathnames.SignUp} element={
                                <SignUp
                                    logo={<Logo size="large" />}
                                />
                            } />
                            <Route path={pathnames.ResetPassword} element={
                                <ResetPassword
                                    logo={<Logo size="large" />}
                                />
                            } />
                            <Route path={pathnames.ActionPages} element={
                                <ActionPages
                                    logo={<Logo size="large" />}
                                />
                            } />
                            <Route path={pathnames.DiditCallback} element={
                                <DiditCallback />
                            } />
                        </Route>
                    </Routes>
                </AppProvider>
                </BrowserRouter>
            </AuthProvider>
        </FireactProvider>
        </ThemeProvider>
    )
}

export default App;
